//Javascript for the WECAN Employer Area Profile functionality
app.EmployerProfile = (
    function () {

        var profile = {

            //Index Page
            Index: function () {

                //When the main user is updated, refresh the access details component to make sure only the main user can get to it
                $(document).on("component-save-complete-MainUserDetails",
                    function () {
                        app.page.components["AccessDetails"][0].startViewMode();
                    });
                //when the school system access details is updated, refresh the lockout component
                $(document).on("component-save-complete-AccessDetails",
                    function () {
                        var component = app.page.components["LoginExplanation"];
                        if (component.length > 0) {
                            app.page.components["LoginExplanation"][0].startViewMode();
                        }
                    });
            }
        };

        return profile;

    }()
);